/**
 * Property management module translations - English
 * Includes: Work Order Management
 */
export default {
  property: {
    // Work Order Management
    workorder: {
      title: 'Work Orders',
      // Stat cards
      statPending: 'Pending',
      statProcessing: 'Processing',
      statCompleted: 'Completed',
      statOverdue: 'Overdue',
      statTodayCreated: 'Created Today',
      statTodayCompleted: 'Completed Today',
      statUrgent: 'Urgent',
      // Search form
      keyword: 'Keyword',
      keywordPlaceholder: 'Order No. / Title',
      orderType: 'Type',
      priority: 'Priority',
      status: 'Status',
      assignedTo: 'Assignee',
      startTime: 'Start Time',
      endTime: 'End Time',
      hideSearch: 'Hide Search',
      showSearch: 'Show Search',
      // Order types
      typeRepair: 'Repair',
      typeComplaint: 'Complaint',
      typeConsult: 'Consultation',
      typeInspection: 'Inspection',
      typeMaintenance: 'Maintenance',
      typeOther: 'Other',
      // Priority
      priorityUrgent: 'Urgent',
      priorityHigh: 'High',
      priorityNormal: 'Normal',
      priorityLow: 'Low',
      // Status
      statusPending: 'Pending',
      statusAssigned: 'Assigned',
      statusProcessing: 'Processing',
      statusCompleted: 'Completed',
      statusVerified: 'Verified',
      statusClosed: 'Closed',
      statusSuspended: 'Suspended',
      statusPool: 'Pool',
      statusPendingApproval: 'Pending Approval',
      // Action buttons
      createOrder: 'New Order',
      assign: 'Assign',
      autoAssign: 'Auto Assign',
      putToPool: 'Put to Pool',
      accept: 'Accept',
      addLog: 'Add Log',
      complete: 'Complete',
      verify: 'Verify',
      closeOrder: 'Close',
      transfer: 'Transfer',
      suspend: 'Suspend',
      resume: 'Resume',
      urge: 'Urge',
      claim: 'Claim',
      submitApproval: 'Submit Approval',
      // Table columns
      orderNo: 'Order No.',
      orderTitle: 'Title',
      merchantName: 'Merchant',
      shopName: 'Asset',
      assignedName: 'Assignee',
      creatorName: 'Creator',
      deadline: 'Deadline',
      createTime: 'Created',
      source: 'Source',
      // Source
      sourceSystem: 'System',
      sourceMerchant: 'Merchant',
      sourcePublic: 'Public',
      sourceInspection: 'Inspection',
      // Form
      formTitle: 'Title',
      formTitlePlaceholder: 'Enter order title',
      formTitleRequired: 'Title is required',
      formType: 'Type',
      formTypeRequired: 'Type is required',
      formPriority: 'Priority',
      formDescription: 'Description',
      formDescriptionPlaceholder: 'Describe the issue in detail',
      formMerchant: 'Merchant',
      formShop: 'Shop',
      formDeadline: 'Deadline',
      formImages: 'Photos',
      // Repair extension
      repairType: 'Repair Type',
      repairTypeElectric: 'Electrical',
      repairTypePlumbing: 'Plumbing',
      repairTypeHvac: 'HVAC',
      repairTypeElevator: 'Elevator',
      repairTypeFire: 'Fire Safety',
      repairTypeSecurity: 'Security',
      repairTypeCleaning: 'Cleaning',
      repairTypeOther: 'Other',
      faultLocation: 'Fault Location',
      faultLocationPlaceholder: 'Enter fault location',
      faultDescription: 'Fault Description',
      faultDescriptionPlaceholder: 'Describe the fault',
      // Dispatch dialog
      dispatchTitle: 'Dispatch Order',
      dispatchDept: 'Department',
      dispatchHandler: 'Handler',
      dispatchHandlerRequired: 'Please select a handler',
      dispatchRemark: 'Remark',
      // Transfer dialog
      transferTitle: 'Transfer Order',
      transferHandler: 'Transfer to',
      transferHandlerRequired: 'Please select a handler',
      transferRemark: 'Reason',
      // Process log
      processTitle: 'Add Process Log',
      processContent: 'Content',
      processContentRequired: 'Content is required',
      processContentPlaceholder: 'Describe the process',
      processImages: 'Photos',
      // Complete
      completeTitle: 'Complete Processing',
      completeContent: 'Result',
      completeContentPlaceholder: 'Describe the final result',
      completeCost: 'Repair Cost',
      // Verify
      verifyTitle: 'Verify Order',
      verifyPassed: 'Passed',
      verifyRejected: 'Rejected',
      verifyResult: 'Result',
      verifyResultRequired: 'Please select result',
      verifyComment: 'Comment',
      verifyCommentPlaceholder: 'Enter verification comment',
      verifyRating: 'Rating',
      // Suspend
      suspendTitle: 'Suspend Order',
      suspendRemark: 'Reason',
      suspendRemarkPlaceholder: 'Enter suspend reason',
      // Detail panel
      detailTitle: 'Order Detail',
      basicInfo: 'Basic Info',
      repairInfo: 'Repair Info',
      processTimeline: 'Timeline',
      timelineCreated: 'Created',
      timelineAssigned: 'Assigned',
      timelineAccepted: 'Accepted',
      timelineProcess: 'Process Log',
      timelineCompleted: 'Completed',
      timelineVerified: 'Verified',
      timelineClosed: 'Closed',
      timelineSuspended: 'Suspended',
      timelineResumed: 'Resumed',
      timelineTransferred: 'Transferred',
      timelineUrged: 'Urged',
      timelineClaimed: 'Claimed',
      // Confirm messages
      confirmDelete: 'Are you sure to delete this order?',
      confirmAccept: 'Are you sure to accept this order?',
      confirmComplete: 'Are you sure to complete?',
      confirmClose: 'Are you sure to close? This cannot be undone.',
      forceCloseRemarkPlaceholder: 'Please enter the reason for closing (optional)',
      confirmResume: 'Are you sure to resume this order?',
      confirmUrge: 'Are you sure to urge this order?',
      confirmClaim: 'Are you sure to claim this order?',
      confirmAutoAssign: 'Auto assign? System will use load-balancing.',
      confirmPutToPool: 'Put this order to the claim pool?',
      confirmSubmitApproval: 'Submit for approval?',
    },
  },
}
